import PropTypes from "prop-types";

const SearchStatus = ({
  resultsRange,
  totalResults,
  keywords,
  selectedFacets,
  handleFacetDismiss,
  filtersText,
}) => {
  const shouldRenderFacets = selectedFacets.length > 0;
  const shouldRenderKeywords = !!keywords;

  const onFacetClick = (value) => {
    handleFacetDismiss(value.id);
  };

  const resultLabel = totalResults === 1 ? "result" : "results";

  const renderSelectedFacets = () => {
    return (
      <div className="search-results__active-facets">
        {filtersText ? <span>{filtersText}</span> : <span>with filters</span>}
        <ul>
          {selectedFacets.map((value) => {
            return (
              <li key={value.id}>
                <span>{value.name}</span>
                <button onClick={() => onFacetClick(value)}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="feather feather-x"
                  >
                    <path d="M18 6L6 18M6 6l12 12" />
                  </svg>
                </button>
              </li>
            );
          })}
        </ul>
      </div>
    );
  };

  return (
    <div className="search-results__status">
      <span>{resultsRange}</span>&nbsp;
      <span>of</span>&nbsp;
      <span>{totalResults}</span>&nbsp;
      <span>{resultLabel}</span>&nbsp;
      {shouldRenderKeywords && <span>for &quot;{keywords}&quot;&nbsp;</span>}
      {shouldRenderFacets && renderSelectedFacets()}
    </div>
  );
};

const { string, number, object, arrayOf, func } = PropTypes;

SearchStatus.propTypes = {
  resultsRange: string.isRequired,
  totalResults: number.isRequired,
  keywords: string,
  selectedFacets: arrayOf(object).isRequired,
  handleFacetDismiss: func.isRequired,
  filtersText: string,
};

SearchStatus.defaultProps = {
  selectedFacets: [],
};

export default SearchStatus;
